var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('../../assets/icons/file.png'),"alt":""}})]),_vm._v(" "),_c('p',{staticClass:"padlr10 phead"},[_vm._v("您的志愿列表生成成功，请点击右上角在Sarari中打开下载。")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6c00e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/download.vue
// module id = null
// module chunks = 